/* tslint:disable */

declare var Object: any;
export interface TermsAndConditionInterface {
  "fileName": string;
  "versionNumber": string;
  "uploadDate": Date;
  "id"?: number;
}

export class TermsAndCondition implements TermsAndConditionInterface {
  "fileName": string;
  "versionNumber": string;
  "uploadDate": Date;
  "id": number;
  constructor(data?: TermsAndConditionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TermsAndCondition`.
   */
  public static getModelName() {
    return "TermsAndCondition";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TermsAndCondition for dynamic purposes.
  **/
  public static factory(data: TermsAndConditionInterface): TermsAndCondition{
    return new TermsAndCondition(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TermsAndCondition',
      plural: 'TermsAndConditions',
      path: 'TermsAndConditions',
      idName: 'id',
      properties: {
        "fileName": {
          name: 'fileName',
          type: 'string'
        },
        "versionNumber": {
          name: 'versionNumber',
          type: 'string'
        },
        "uploadDate": {
          name: 'uploadDate',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
